module.exports = __webpack_public_path__ + "img/die-tablet.39664cdf.png";